module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_ TWO-TONE LEATHER_deskstop.84606bcf.jpg";